import { type LDClient, LDPlugin, useLDClient } from "launchdarkly-vue-client-sdk";
type Variant = "Complex" | "Simple" | "Sportsbook";
// @ts-ignore
export default defineNuxtPlugin(async (nuxtApp): Promise<{ provide: { ldClient: LDClient; ldVariation: Variant } }> => {
	try {
		const clientSideID = "684bfa8ef36d7a092e1fab43";
		const { darklyEnabled } = nuxtApp.$config.public;
		const { countryISOCode } = useISOCode();

		const darkleyRegions = darklyEnabled.split(",");

		if (countryISOCode.value && darkleyRegions.includes(countryISOCode.value)) {
			nuxtApp.vueApp.use(LDPlugin, {
				clientSideID,
			});
			const ldClient = useLDClient();
			await ldClient.waitForInitialization(5);
			const ldVariation = ldClient.variation("HomepageExperiment", "Sportsbook");
			return {
				provide: {
					ldClient,
					ldVariation,
				},
			};
		}
	} catch (e) {}
});
